/* Magnetik: Shopify-aware buy box behaviour.
 *
 * REQ 1  add to cart -> POST /cart/add.js (native Ajax Cart API)
 * REQ 3  every money string comes from Liquid; this file only swaps between them
 *
 * Add to cart now STAYS on the page and confirms, instead of jumping straight
 * to checkout. Bundle pricing is handled by Shopify automatic discounts, so no
 * discount code is passed through the URL any more.
 */
(function () {
  'use strict';

  var pdp = document.getElementById('pdp');
  if (!pdp) return;

  var form     = document.getElementById('product-form');
  var idSelect = document.getElementById('variant-id');
  var qtyInput = document.getElementById('qty');
  var atc      = document.getElementById('atc');
  var atcText  = document.getElementById('atc-text');
  var note     = document.getElementById('atc-note');
  var priceEl  = document.getElementById('price');
  var noteEl   = document.getElementById('price-note');
  var bundleBox= document.getElementById('bundles');
  var mainImgs = [].slice.call(document.querySelectorAll('#gal-main img'));
  var thumbs   = [].slice.call(document.querySelectorAll('#gal-thumbs button'));

  var state = { qty: 1 };
  var at = 0;

  /* ---------------- gallery ---------------- */

  /* Dots. Built in JS and shown only on small screens by CSS, so the desktop
     thumbnail strip is completely unaffected. */
  var dotsWrap = null;
  (function buildDots() {
    var galEl = document.querySelector('.gal');
    if (!galEl || mainImgs.length < 2) return;
    dotsWrap = document.createElement('div');
    dotsWrap.className = 'gal-dots';
    dotsWrap.setAttribute('role', 'tablist');
    dotsWrap.setAttribute('aria-label', 'Product images');
    mainImgs.forEach(function (_, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('role', 'tab');
      b.setAttribute('aria-label', 'Image ' + (i + 1));
      b.addEventListener('click', function () { showSlide(i); });
      dotsWrap.appendChild(b);
    });
    var main = document.getElementById('gal-main');
    if (main && main.parentNode) main.parentNode.insertBefore(dotsWrap, main.nextSibling);
  })();


  /* ---------------- gallery: promote the deferred slides ----------------
     Slides 2..n ship with data-src so they do not compete with the LCP image.
     Promote them the moment the first slide is done -- and immediately if the
     customer touches the gallery before that -- so a slide is never blank. */
  var slidesHydrated = false;
  function hydrateSlides() {
    if (slidesHydrated) return;
    slidesHydrated = true;
    mainImgs.forEach(function (img) {
      var ds = img.getAttribute('data-src');
      if (!ds) return;
      var dss = img.getAttribute('data-srcset');
      if (dss) { img.setAttribute('srcset', dss); img.removeAttribute('data-srcset'); }
      img.setAttribute('src', ds);
      img.removeAttribute('data-src');
    });
  }

  (function scheduleHydrate() {
    var first = mainImgs[0];
    if (!first) return;
    if (first.complete) { hydrateSlides(); return; }
    first.addEventListener('load', hydrateSlides, { once: true });
    first.addEventListener('error', hydrateSlides, { once: true });
    /* backstop: never leave them unhydrated if the first image stalls */
    window.addEventListener('load', hydrateSlides, { once: true });
  })();

  function showSlide(n) {
    hydrateSlides();
    if (!mainImgs.length) return;
    at = (n + mainImgs.length) % mainImgs.length;
    for (var i = 0; i < mainImgs.length; i++) mainImgs[i].classList.toggle('on', i === at);
    for (var j = 0; j < thumbs.length; j++) thumbs[j].setAttribute('aria-current', j === at ? 'true' : 'false');
    if (dotsWrap) {
      var ds = dotsWrap.children;
      for (var k = 0; k < ds.length; k++) ds[k].setAttribute('aria-current', k === at ? 'true' : 'false');
    }
  }
  thumbs.forEach(function (b, n) { b.addEventListener('click', function () { showSlide(n); }); });

  var prev = document.getElementById('gal-prev');
  var next = document.getElementById('gal-next');
  if (prev) prev.addEventListener('click', function () { showSlide(at - 1); });
  if (next) next.addEventListener('click', function () { showSlide(at + 1); });

  /* keyboard arrows while the gallery has focus */
  var gal = document.getElementById('gal-main');
  if (gal) {
    gal.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  { e.preventDefault(); showSlide(at - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); showSlide(at + 1); }
    });
  }

  /* swipe on touch */
  var x0 = null;
  if (gal) {
    gal.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    gal.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 45) showSlide(at + (dx < 0 ? 1 : -1));
      x0 = null;
    }, { passive: true });
  }

  /* Jump the gallery to the image for a colour.
     Variants carry no featured media on this product, so match on the image
     filename (pb-black / pb-white / pb-pink / pb-royal) and fall back to the
     alt text. Falls through silently if neither matches. */
  function showColourImage(value) {
    if (!value) return;
    var key = String(value).toLowerCase().replace(/[^a-z0-9]+/g, '-');
    for (var i = 0; i < mainImgs.length; i++) {
      var src = (mainImgs[i].getAttribute('src') || mainImgs[i].getAttribute('data-src') || '').toLowerCase();
      if (src.indexOf('pb-' + key) > -1) { showSlide(i); return; }
    }
    for (var k = 0; k < mainImgs.length; k++) {
      var alt = (mainImgs[k].getAttribute('alt') || '').toLowerCase();
      if (alt.indexOf(' in ' + key) > -1) { showSlide(k); return; }
    }
  }

  function showMedia(id) {
    if (!id) return false;
    for (var i = 0; i < mainImgs.length; i++) {
      if (mainImgs[i].getAttribute('data-media-id') === String(id)) { showSlide(i); return true; }
    }
    return false;
  }

  /* ---------------- product options -> real variant ---------------- */
  var optionGroups = [].slice.call(pdp.querySelectorAll('[data-option-position]'));

  function selectedOptions() {
    var picked = {};
    optionGroups.forEach(function (g) {
      var on = g.querySelector('[aria-checked="true"]');
      if (on) picked[g.getAttribute('data-option-position')] = on.getAttribute('data-option-value');
    });
    return picked;
  }

  function syncVariant(changedValue, isColour) {
    var picked = selectedOptions();
    var opts = idSelect.options;
    for (var i = 0; i < opts.length; i++) {
      var o = opts[i], ok = true;
      for (var pos in picked) {
        if (!Object.prototype.hasOwnProperty.call(picked, pos)) continue;
        if (o.getAttribute('data-o' + pos) !== picked[pos]) { ok = false; break; }
      }
      if (ok) {
        idSelect.selectedIndex = i;
        /* prefer real variant media; otherwise match the colour image */
        if (!showMedia(o.getAttribute('data-media')) && isColour) showColourImage(changedValue);
        var avail = !o.disabled;
        atc.disabled = !avail;
        atcText.textContent = avail ? 'Add to cart' : 'Sold out';
        idSelect.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }
    }
  }

  optionGroups.forEach(function (group) {
    var isColour = group.classList.contains('colors');
    var choices = [].slice.call(group.querySelectorAll('[data-option-value]'));
    choices.forEach(function (btn) {
      function pick() {
        choices.forEach(function (c) { c.setAttribute('aria-checked', 'false'); c.removeAttribute('data-on'); });
        btn.setAttribute('aria-checked', 'true');
        btn.setAttribute('data-on', '1');
        var lbl = group.previousElementSibling && group.previousElementSibling.querySelector('b');
        var val = btn.getAttribute('data-option-value');
        if (lbl) lbl.textContent = val;
        syncVariant(val, isColour);
        if (isColour) renderUnitColours();
      }
      btn.addEventListener('click', pick);
      btn.addEventListener('keydown', function (e) {
        if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); pick(); }
      });
    });
  });

  /* ---------------- bundle tiers ---------------- */
  function priceFor(q) {
    if (q === 1) return priceEl.getAttribute('data-unit-money');
    if (q === 3) return priceEl.getAttribute('data-three-money');
    return priceEl.getAttribute('data-two-money');
  }
  function noteFor(q) {
    var n = q === 1 ? noteEl.getAttribute('data-one-note')
          : q === 3 ? noteEl.getAttribute('data-three-note')
          : noteEl.getAttribute('data-two-note');
    /* the gift deal ended while the page was open: drop the gift mention */
    if (n && document.documentElement.classList.contains('deal-over')) {
      var cut = n.indexOf(' free gifts worth');
      var dot = cut > -1 ? n.lastIndexOf('\u00b7', cut) : -1;
      if (dot > -1) n = n.slice(0, dot).trim();
    }
    return n;
  }

  var tiers = bundleBox ? [].slice.call(bundleBox.querySelectorAll('.bundle[data-qty]')) : [];
  function pickTier(el) {
    tiers.forEach(function (t) { t.removeAttribute('data-on'); t.setAttribute('aria-checked', 'false'); });
    el.setAttribute('data-on', '1');
    el.setAttribute('aria-checked', 'true');
    state.qty = parseInt(el.getAttribute('data-qty'), 10) || 1;
    qtyInput.value = state.qty;
    priceEl.textContent = priceFor(state.qty);
    var wasEl = document.getElementById('price-was');
    if (wasEl) wasEl.textContent = wasEl.getAttribute(state.qty === 3 ? 'data-three-was' : state.qty === 2 ? 'data-two-was' : 'data-unit-was');
    noteEl.innerHTML = noteFor(state.qty);
    renderUnitColours();
  }
  tiers.forEach(function (el) {
    el.addEventListener('click', function () { pickTier(el); });
    el.addEventListener('keydown', function (e) {
      if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); pickTier(el); }
    });
  });

  /* ---------------- per-unit colours for multi-packs ----------------
     A 3-pack should let someone take one white, one pink and one black.
     Each unit gets its own picker; on add we post one line per unit and let
     Shopify merge identical variants itself. */
  var unitWrap = document.getElementById('unit-colors');

  /* colour value -> variant id, read from the real <select> so it can never
     drift from Shopify's variant list */
  function colourMap() {
    var map = [];
    var opts = idSelect ? idSelect.options : [];
    for (var i = 0; i < opts.length; i++) {
      var val = opts[i].getAttribute('data-o1');
      if (val && !map.some(function (m) { return m.value === val; })) {
        map.push({ value: val, id: opts[i].value, disabled: opts[i].disabled });
      }
    }
    return map;
  }

  function currentColour() {
    var on = pdp.querySelector('.colors [aria-checked="true"]');
    return on ? on.getAttribute('data-option-value') : (colourMap()[0] || {}).value;
  }

  function renderUnitColours() {
    if (!unitWrap) return;
    var colours = colourMap();
    if (state.qty < 2 || colours.length < 2) {
      unitWrap.hidden = true;
      unitWrap.innerHTML = '';
      return;
    }

    /* Only remember rows the customer actually touched. Untouched rows keep
       following the main colour picker above. */
    var previous = [].slice.call(unitWrap.querySelectorAll('[data-unit]'))
      .map(function (r) { return r.getAttribute('data-user') === '1' ? r.getAttribute('data-picked') : null; });

    var html = '<div class="unit-colors-head">Choose a colour for each</div>';
    for (var u = 0; u < state.qty; u++) {
      var picked = previous[u] || currentColour();
      html += '<div class="unit-row" data-unit="' + u + '" data-picked="' + picked + '"' +
                (previous[u] ? ' data-user="1"' : '') + '>' +
                '<span class="unit-n">' + (u + 1) + '</span>' +
                '<div class="unit-swatches">';
      for (var c = 0; c < colours.length; c++) {
        var col = colours[c];
        var key = col.value.toLowerCase().replace(/[^a-z0-9]+/g, '-');
        html += '<button type="button" class="c-' + key + '"' +
                ' data-value="' + col.value + '" data-id="' + col.id + '"' +
                (col.disabled ? ' disabled' : '') +
                ' aria-label="' + col.value + '"' +
                ' aria-checked="' + (col.value === picked ? 'true' : 'false') + '" role="radio"></button>';
      }
      html += '</div><span class="unit-name">' + picked + '</span></div>';
    }
    unitWrap.innerHTML = html;
    unitWrap.hidden = false;
  }

  if (unitWrap) {
    unitWrap.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.unit-swatches button');
      if (!b || b.disabled) return;
      var row = b.closest('.unit-row');
      row.querySelectorAll('button').forEach(function (x) { x.setAttribute('aria-checked', 'false'); });
      b.setAttribute('aria-checked', 'true');
      row.setAttribute('data-picked', b.getAttribute('data-value'));
      row.setAttribute('data-user', '1');
      var nm = row.querySelector('.unit-name');
      if (nm) nm.textContent = b.getAttribute('data-value');
    });
  }

  /* what actually goes to /cart/add.js */
  function buildItems() {
    var rows = unitWrap && !unitWrap.hidden
      ? [].slice.call(unitWrap.querySelectorAll('.unit-row'))
      : [];

    if (!rows.length) {
      return [{ id: Number(idSelect.value), quantity: state.qty }];
    }

    var counts = {};
    rows.forEach(function (r) {
      var b = r.querySelector('[aria-checked="true"]');
      var id = b ? b.getAttribute('data-id') : idSelect.value;
      counts[id] = (counts[id] || 0) + 1;
    });
    return Object.keys(counts).map(function (id) {
      return { id: Number(id), quantity: counts[id] };
    });
  }

  /* ---------------- cart count in the header ---------------- */
  function refreshCount() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var els = document.querySelectorAll('[data-cart-count]');
        for (var i = 0; i < els.length; i++) {
          els[i].textContent = c.item_count;
          els[i].setAttribute('data-empty', c.item_count === 0 ? 'true' : 'false');
        }
        return c;
      })
      .catch(function () {});
  }

  /* ---------------- add to cart: stay on the page ---------------- */
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (atc.disabled) return;
      atc.disabled = true;
      atcText.textContent = 'Adding...';
      if (note) { note.textContent = ''; note.classList.remove('err'); }

      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      fetch(root.replace(/\/$/, '') + '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: buildItems() })
      })
        .then(function (res) {
          return res.json().then(function (d) {
            if (!res.ok) throw new Error(d.description || d.message || 'Could not add to cart');
            return d;
          });
        })
        .then(function () {
          /* Slide the drawer in on every screen size. Mobile used to navigate
             to /cart, which meant a full page load -- seconds of blank waiting
             right at the moment of purchase intent. The drawer costs one
             section fetch instead, and refresh() already puts the bundle code
             on the cart before rendering, so the totals are still Liquid's. */
          if (window.MagnetikDrawer) {
            return window.MagnetikDrawer.refresh().then(function () {
              window.MagnetikDrawer.open();
            });
          }
          return refreshCount();
        })
        .then(function () {
          atc.disabled = false;
          atcText.textContent = 'Add to cart';
          if (note) { note.textContent = ''; note.classList.remove('ok', 'err'); }
        })
        .catch(function (err) {
          atc.disabled = false;
          atcText.textContent = 'Add to cart';
          if (note) { note.textContent = err.message || 'Something went wrong.'; note.classList.add('err'); }
        });
    });
  }

  /* ---------------- mobile: colours move under the gallery ----------------
     Done by moving the nodes, because .colors sits inside the product form
     nested in .buy, and no amount of CSS order can lift it into .gal.
     A marker element remembers the desktop position so the move is reversible
     and the desktop layout is never altered. The swatches are type="button"
     and drive the hidden <select name="id">, which stays in the form, so
     moving them cannot affect submission. */
  (function mobileColours() {
    var colours = document.querySelector('#pdp .colors');
    var galEl   = document.querySelector('.gal');
    /* Mobile home for the swatches: directly under the price row, so the price is
       on screen without scrolling. Falls back to the gallery if the slot is gone.
       Presentation only -- the hidden <select name="id"> never moves. */
    var slot    = document.getElementById('colour-slot') || galEl;
    if (!colours || !slot) return;

    var label = colours.previousElementSibling;
    if (label && !label.classList.contains('opt-label')) label = null;

    var marker = document.createComment('colours-home');
    colours.parentNode.insertBefore(marker, label || colours);

    var moved = false;
    var mq = window.matchMedia('(max-width: 960px)');

    function apply() {
      if (mq.matches && !moved) {
        if (label) slot.appendChild(label);
        slot.appendChild(colours);
        colours.classList.add('colors-mobile');
        moved = true;
      } else if (!mq.matches && moved) {
        if (label) marker.parentNode.insertBefore(label, marker);
        marker.parentNode.insertBefore(colours, marker);
        colours.classList.remove('colors-mobile');
        moved = false;
      }
    }

    if (mq.addEventListener) mq.addEventListener('change', apply);
    else if (mq.addListener) mq.addListener(apply);
    apply();
  })();

  /* ---------------- init ---------------- */
  for (var i = 0; i < tiers.length; i++) {
    if (tiers[i].getAttribute('data-on') === '1') { pickTier(tiers[i]); break; }
  }
  refreshCount();
})();
